// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2qZm-","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__19UI2"};